var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82 3.846c-.34 0-.665.131-.906.366-.24.234-.375.552-.375.884v.416h15.384v-.416c0-.332-.135-.65-.375-.884a1.299 1.299 0 0 0-.907-.366H2.821zm14.103 3.75H1.54v5c0 .331.135.65.375.884.24.234.567.366.907.366h12.82c.34 0 .666-.132.907-.366.24-.235.375-.553.375-.884v-5zM3.248 11.554c0-.166.068-.325.188-.442a.65.65 0 0 1 .453-.183h1.282a.65.65 0 0 1 .453.183.617.617 0 0 1 0 .884.65.65 0 0 1-.453.183H3.889a.65.65 0 0 1-.453-.183.617.617 0 0 1-.188-.442zm4.06-.625a.65.65 0 0 0-.453.183.617.617 0 0 0 0 .884.65.65 0 0 0 .453.183h2.991a.65.65 0 0 0 .454-.183.617.617 0 0 0 0-.884.65.65 0 0 0-.454-.183H7.308z",
    fill: "#253331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.549bf4120ea55d83b5ce1b89d365c4bc.svg";
export { ForwardRef as ReactComponent };